/**
 * ## Block component
 *
 * A Block is a self monitoring/updating piece that is created once during run time.
 * Groups can be used to create a dynamic accordion system. For all things static use the
 * 'accordion' component.
 *
 * @module src/components/block
 *
 */

"use strict";

const conf = require("../../config");
const location = require("../../controllers/location");
const icons = require("../../components/icons");
const moment = require("moment-timezone");
const func = require("../../controllers/func");
const l = require("../../common").localization;

const init = {};
const itemHeight = 69;

const indexToTime = (index, time24) => {
  const hh = Math.floor(index / 4);
  const mm = `0${(index % 4) * 15}`.slice(-2);
  if (!time24) {
    return moment(`${hh}:${mm}`, "HH:mm").format(l.translate("h:mm a"));
  }
  return moment(`${hh}:${mm}`, "HH:mm").format("H:mm");
};

const destroy = () => {
  $("#component_catch").css("display", "none");
};

const filter = (filterBy) => {
  $(".block_item").each((index) => {
    if (
      $(this)
        .data("filter")
        .toString()
        .toLowerCase()
        .indexOf(filterBy.toLowerCase()) > -1 ||
      !filterBy
    ) {
      $(this).show();
    } else {
      $(this).hide();
    }
  });
};

const formatCell = (cell) => {
  if (cell.length === 10) {
    return `(${cell.substring(0, 3)}) ${cell.substring(3, 6)}-${cell.substring(
      6,
      10
    )}`;
  }
  return cell;
};

const genIcon = (icon, theme) => {
  let output = "";
  output += `<div class="block_item_icon ${theme}">`;
  output += icons.lib[icon];
  output += "</div>";
  return output;
};

const genIcons = (notes) => {
  let output = "";
  for (let n = 0; n < notes.length; ++n) {
    if (notes[n].active) {
      switch (notes[n].value) {
        case "Incomplete Party":
        case l.translate("Incomplete Party"): {
          output += genIcon("usertimes", "theme_purple");
          break;
        }
        case "Booster":
        case l.translate("Booster"): {
          output += genIcon("smile", "");
          break;
        }
        case "Birthday":
        case l.translate("Birthday"): {
          output += genIcon("birthdaycake", "");
          break;
        }
        case "Anniversary":
        case l.translate("Anniversary"): {
          output += genIcon("heart", "");
          break;
        }
        case "Wheelchair":
        case l.translate("Wheelchair"): {
          output += genIcon("wheelchair", "");
          break;
        }
        case "VIP":
        case l.translate("VIP"): {
          output += genIcon("star", "theme_blue");
          break;
        }
        default: {
          output += "";
          break;
        }
      }
    }
  }
  return output;
};

/**
 * block display.
 */
const create = (opt, data, callback) => {
  if (opt.kd.usage !== "embed") {
    const targetDiv = opt.targetDiv;
    const loc = opt.kd.doc("location")[0];
    let time24 = false;

    if (loc.hasOwnProperty("time24") && loc.time24) {
      time24 = true;
    }

    if (!init[targetDiv]) {
      init[targetDiv] = {
        exist: false,
      };
      if (data.expand) {
        init[targetDiv].expanded = true;
      } else {
        init[targetDiv].expanded = false;
      }

      // set this until proper start structure is in place

      if (opt.hasOwnProperty("static") && opt.static) {
        //
      } else {
        opt.kd.on("activity.update", () => {
          init[targetDiv].height = $(`#block_body_${targetDiv}`).outerHeight();
          init[targetDiv].scroll = $(`#block_body_${targetDiv}`).scrollTop();
          // console.log('block activity.update');
          create(opt, data, callback);
        });

        opt.kd.on("location.update", () => {
          init[targetDiv].height = $(`#block_body_${targetDiv}`).outerHeight();
          init[targetDiv].scroll = $(`#block_body_${targetDiv}`).scrollTop();
          // console.log('block location.update');
          create(opt, data, callback);
        });

        opt.kd.on("reservation.update", () => {
          init[targetDiv].height = $(`#block_body_${targetDiv}`).outerHeight();
          init[targetDiv].scroll = $(`#block_body_${targetDiv}`).scrollTop();
          create(opt, data, callback);
        });

        opt.kd.on("block.update", () => {
          init[targetDiv].height = $(`#block_body_${targetDiv}`).outerHeight();
          init[targetDiv].scroll = $(`#block_body_${targetDiv}`).scrollTop();
          create(opt, data, callback);
        });

        init[targetDiv].interval = setInterval(() => {
          init[targetDiv].height = $(`#block_body_${targetDiv}`).outerHeight();
          init[targetDiv].scroll = $(`#block_body_${targetDiv}`).scrollTop();
          create(opt, data, callback);
        }, data.refresh * 2 * (0.9 + Math.random() * 0.1) * 1000);
      }
    }

    let thisHTML = "";
    init[targetDiv].minHeight = data.height.min;
    if (data.height.hasOwnProperty("max")) {
      init[targetDiv].maxHeight = data.height.max;
    }
    switch (data.type) {
      case "noshows":
      case "precheck":
      case "waitlist": {
        init[targetDiv].height = $(`#block_body_${targetDiv}`).outerHeight();
        init[targetDiv].scroll = $(`#block_body_${targetDiv}`).scrollTop();
        const now = Math.floor(Date.now() / 1000);
        const start = now - data.waited.max * 60;
        const end = now - data.waited.min * 60;
        const preresult = opt.kd.whereSort(
          "activity",
          (obj) => {
            if (
              obj.hasOwnProperty("status") &&
              obj.hasOwnProperty("size") &&
              obj.status >= data.status.min &&
              obj.status <= data.status.max &&
              obj.size >= data.size.min &&
              obj.size <= data.size.max &&
              obj.statusTimes.added >= start &&
              obj.statusTimes.added <= end
            ) {
              return true;
            }
          },
          (obj1, obj2) => {
            if (obj1.statusTimes.added == obj2.statusTimes.added) {
              return 0;
            }
            if (obj1.statusTimes.added > obj2.statusTimes.added) {
              return 1;
            }
            if (obj1.statusTimes.added < obj2.statusTimes.added) {
              return -1;
            }
          }
        );
        // check for options filters and push each one into new result set
        const result = [];
        for (let i = 0; i < preresult.length; ++i) {
          if (
            opt.hasOwnProperty("filter") &&
            opt.filter.hasOwnProperty("name") &&
            opt.filter.name &&
            opt.kd.localstore.data.filter.name !== ""
          ) {
            if (
              opt.kd.localstore.data.filter.name.length === 0 ||
              preresult[i].name
                .toLowerCase()
                .indexOf(opt.kd.localstore.data.filter.name.toLowerCase()) > -1
            ) {
              result.push(preresult[i]);
            }
          } else if (
            opt.hasOwnProperty("filter") &&
            opt.filter.hasOwnProperty("time") &&
            opt.filter.time &&
            opt.kd.localstore.data.filter.time > 0
          ) {
            switch (opt.kd.localstore.data.filter.time) {
              case 1: {
                result.push(preresult[i]);
                break;
              }
              case 2: {
                const quoted =
                  preresult[i].statusTimes.added + preresult[i].quoted * 60;
                if (quoted <= parseInt(moment().format("X"), 10)) {
                  result.push(preresult[i]);
                }
                break;
              }
              case 3: {
                const quoted =
                  preresult[i].statusTimes.added + preresult[i].quoted * 60;
                if (
                  quoted <= parseInt(moment().add(5, "minutes").format("X"), 10)
                ) {
                  result.push(preresult[i]);
                }
                break;
              }
              case 4: {
                if (preresult[i].status === 2) {
                  result.push(preresult[i]);
                }
                break;
              }
              default: {
                result.push(preresult[i]);
                break;
              }
            }
          } else {
            result.push(preresult[i]);
          }
        }

        thisHTML += `<div class="block_header theme_bg_night_gradient" \
                        id="block_header_${targetDiv}">`;
        thisHTML += `<div class="block_header_h3">${result.length} \
                        <div class="block_header_float" id="block_header_icon_${targetDiv}">\
                        ${icons.lib.doubledown}\
                        </div></div>`;
        thisHTML += `<div class="block_header_h1">${data.h1}</div>`;
        let h2 = data.h2;
        if (data.hasOwnProperty("waitSize")) {
          let waitTime = location.getCurrentWait(data.waitSize);
          if (waitTime < 0) {
            waitTime = 0;
          }
          h2 = `${waitTime}-${waitTime + 5}m`;
        }
        thisHTML += `<div class="block_header_h2">${h2}</div>`;
        thisHTML += "</div>";
        thisHTML += `<div class="block_body block_group_${data.group}" \
                        id="block_body_${targetDiv}">`;
        for (let i = 0; i < result.length; ++i) {
          if (
            !result[i].hasOwnProperty("preference") ||
            result[i].preference === undefined
          ) {
            result[i].preference = "";
          }

          result[i].waited = Math.floor(
            (now - result[i].statusTimes.added) / 60
          );
          const waited = `${result[i].waited} of ${result[i].quoted}m`;

          if (
            !result[i].hasOwnProperty("alerts") ||
            result[i].alerts === undefined
          ) {
            result[i].alerts = 0;
          }

          if (
            !result[i].hasOwnProperty("res_id") ||
            result[i].res_id === undefined
          ) {
            result[i].res_id = 0;
          }

          let itemColor = "";
          let quoted = result[i].statusTimes.added + result[i].quoted * 60;
          if (isNaN(quoted) || quoted === undefined) {
            quoted = 2;
          }
          if (result[i].res_id.length > 1) {
            itemColor = ' style="background-color: #42bcf4;"';
          } else if (result[i].status === 2) {
            itemColor = ' style="background-color: #a8ff38; color:#000;"';
          } else if (
            result[i].status === 1 &&
            quoted <= parseInt(moment().format("X"), 10)
          ) {
            itemColor = ' style="background-color: #ff0101; color:#000;"';
          } else if (
            result[i].status === 1 &&
            quoted <= parseInt(moment().add(5, "minutes").format("X"), 10)
          ) {
            itemColor = ' style="background-color: #ffa202; color:#000;"';
          }

          thisHTML += `<div class="block_item block_item_${targetDiv}" `;
          thisHTML += `id="block_item_${targetDiv}_${i}" data-id="${result[i]._id}" `;
          /*
                thisHTML += `data-filter="${result[i].name}" `;
                // let now = moment().format('X');
                thisHTML += `data-quoted="${result[i].statusTimes.added + (result[i].quoted * 60)}"
                `;
                let alerted = 0;
                if (result[i].status === 2) {
                    alerted = 1;
                }
                thisHTML += `data-alerted="${alerted}" `;
                thisHTML += `data-preference="${result[i].preference}" `;
                let standardNotes = '';
                for (let n = 0; n < result[i].notes.length; ++n) {
                    if (result[i].notes[n].active) {
                        standardNotes += `${result[i].notes[n].value},`;
                    }
                }
                thisHTML += `data-notes="${result[i].preference},\
                    ${result[i].customNotes},${standardNotes}"`;
                */
          thisHTML += ">";
          thisHTML += `<div class="block_item_size" ${itemColor}>${result[i].size}</div>`;
          thisHTML += `<div class="block_item_name">${result[i].name}</div>`;
          thisHTML += `<div class="block_item_waited">${waited}</div>`;
          thisHTML += '<div class="clear"></div>';
          thisHTML += `<div class="block_item_preference">${result[i].preference}</div>`;
          thisHTML += `<div class="block_item_alerts">${result[i].alerts} \
                            ${icons.lib.bell}</div>`;
          thisHTML += '<div class="clear"></div>';
          if (
            result[i].hasOwnProperty("res_id") &&
            result[i].res_id.length > 1
          ) {
            thisHTML +=
              '<div class="block_item_icon block_item_icon_highlight">' +
              '<i class="fas fa-calendar-alt"></i></div>';
          }
          thisHTML += genIcons(result[i].notes);
          let added = "";
          if (result[i].statusTimes.hasOwnProperty("added")) {
            added = moment(result[i].statusTimes.added * 1000).format(
              l.translate("h:mm a")
            );
          }
          thisHTML += `<div class="block_item_added">${added}</div>`;
          thisHTML += '<div class="clear"></div>';
          thisHTML += "</div>";
        }
        thisHTML += "</div>";
        $(`#${targetDiv}`).html(thisHTML);
        if (init[targetDiv].minHeight >= result.length * itemHeight) {
          init[targetDiv].minHeight = result.length * itemHeight;
        }
        if (!init[targetDiv].exist) {
          init[targetDiv].exist = true;
          TweenMax.to(`#block_body_${targetDiv}`, 0, {
            height: 0,
          });
          if (data.expand) {
            if (init[targetDiv].hasOwnProperty("maxHeight")) {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: init[targetDiv].maxHeight,
                }
              );
            } else {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: result.length * itemHeight,
                }
              );
            }
          } else {
            TweenMax.to(
              `#block_body_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                height: init[targetDiv].minHeight,
              }
            );
          }
        } else {
          TweenMax.to(`#block_body_${targetDiv}`, 0, {
            height: init[targetDiv].height,
          });
          if (init[targetDiv].expanded) {
            if (init[targetDiv].hasOwnProperty("maxHeight")) {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: init[targetDiv].maxHeight,
                }
              );
            } else {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: result.length * itemHeight,
                }
              );
            }
          } else {
            TweenMax.to(`#block_body_${targetDiv}`, 0, {
              height: init[targetDiv].minHeight,
            });
          }
          TweenMax.to(`#block_body_${targetDiv}`, 0, {
            scrollTo: init[targetDiv].scroll,
          });
        }
        $(`#block_header_${targetDiv}`).off();
        $(`#block_header_${targetDiv}`).fastClick((e) => {
          e.stopPropagation();
          if (!init[targetDiv].expanded) {
            init[targetDiv].expanded = true;
            TweenMax.to(
              `#block_header_icon_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                rotation: 0,
              }
            );
            if (init[targetDiv].hasOwnProperty("maxHeight")) {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: init[targetDiv].maxHeight,
                }
              );
            } else {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: result.length * itemHeight,
                }
              );
            }
          } else {
            init[targetDiv].expanded = false;
            TweenMax.to(
              `#block_header_icon_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                rotation: 180,
              }
            );
            TweenMax.to(
              `#block_body_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                height: init[targetDiv].minHeight,
              }
            );
          }
        });
        $(`.block_item_${targetDiv}`).off();
        $(`.block_item_${targetDiv}`).fastClick((e) => {
          // e.stopPropagation();
          callback(null, e.target.id, $(`#${e.target.id}`).data("id"));
        });
        break;
      }
      case "stats": {
        init[targetDiv].height = $(`#block_body_${targetDiv}`).outerHeight();
        init[targetDiv].scroll = $(`#block_body_${targetDiv}`).scrollTop();

        thisHTML += `<div class="block_header theme_bg_night_gradient" \
                        id="block_header_${targetDiv}">`;
        thisHTML += `<div class="block_header_h3s">\
                        <div class="block_header_float" id="block_header_icon_${targetDiv}"></div>
                        </div>`;
        thisHTML += `<div class="block_header_h1">${data.h1}</div>`;

        // thisHTML += `<div class="block_header_h2">Header here</div>`;
        thisHTML += "</div>";
        thisHTML += `<div class="block_body block_group_${data.group}" \
                        id="block_body_${targetDiv}">`;

        switch (data.mode) {
          case "avg": {
            thisHTML += `<div class="stats_header_left stats_header">${l.translate(
              "Party"
            )}\
                    <br/>${l.translate("Size")}</div>`;
            thisHTML += `<div class="stats_header_center stats_header">${l.translate(
              "Avg."
            )}\
                    <br/>${l.translate("Quoted")}</div>`;
            thisHTML += `<div class="stats_header_right stats_header">${l.translate(
              "Avg."
            )}\
                    <br/>${l.translate("Waited")}</div>`;
            for (let r = 2; r <= 16; r = r + 2) {
              for (let c = 1; c <= 3; ++c) {
                thisHTML += `<div class="stats_field" \
                            id="stats_avg_${data.switch}_${r}_${c}"></div>`;
              }
            }
            break;
          }
          case "turn": {
            thisHTML += `<div class="stats_header_left stats_header">${l.translate(
              "Party"
            )}\
                    <br/>${l.translate("Size")}</div>`;
            thisHTML += `<div class="stats_header_center stats_header">${l.translate(
              "Avg."
            )}\
                    <br/>${l.translate("Turn")}</div>`;
            thisHTML +=
              '<div class="stats_header_right stats_header">&nbsp;</br>&nbsp;</div>';
            for (let r = 2; r <= 16; r = r + 2) {
              for (let c = 1; c <= 3; ++c) {
                thisHTML += `<div class="stats_field" \
                            id="stats_turn_${data.switch}_${r}_${c}"></div>`;
              }
            }
            break;
          }
          case "server": {
            thisHTML += `<div class="stats_header_left stats_header">${l.translate(
              "Server"
            )}\
                    </br>${l.translate("Name")}</div>`;
            thisHTML += `<div class="stats_header_center stats_header">${l.translate(
              "Avg."
            )}\
                    <br/>${l.translate("Turn")}</div>`;
            thisHTML += `<div class="stats_header_right stats_header">${l.translate(
              "Cover"
            )}\
                    <br/>${l.translate("Count")}</div>`;
            thisHTML += `<div id="stats_server_${data.switch}_box">test</div>`;
            /*
                for (let r = 2; r <= 16; r = r + 2) {
                    for (let c = 1; c <= 3; ++c) {
                        thisHTML += `<div class="stats_field" \
                            id="stats_server_${data.switch}_${r}_${c}"></div>`;
                    }
                }
                */
            break;
          }
          default: {
            break;
          }
        }

        thisHTML += "</div>";
        $(`#${targetDiv}`).html(thisHTML);
        if (conf.vars.language !== "en") {
          $(".stats_header").css("font-size", "10px");
        }
        init[targetDiv].minHeight = 0;
        if (!init[targetDiv].exist) {
          init[targetDiv].exist = true;
          TweenMax.to(`#block_body_${targetDiv}`, 0, {
            height: 0,
          });
          if (data.expand) {
            TweenMax.to(
              `#block_body_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                height: init[targetDiv].maxHeight,
              }
            );
          } else {
            TweenMax.to(
              `#block_body_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                height: init[targetDiv].minHeight,
              }
            );
          }
        } else {
          TweenMax.to(`#block_body_${targetDiv}`, 0, {
            height: init[targetDiv].height,
          });
          if (init[targetDiv].expanded) {
            if (init[targetDiv].hasOwnProperty("maxHeight")) {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: init[targetDiv].maxHeight,
                }
              );
            } else {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: init[targetDiv].minHeight,
                }
              );
            }
          } else {
            TweenMax.to(`#block_body_${targetDiv}`, 0, {
              height: init[targetDiv].minHeight,
            });
          }
          TweenMax.to(`#block_body_${targetDiv}`, 0, {
            scrollTo: init[targetDiv].scroll,
          });
        }
        $(`#block_header_${targetDiv}`).off();
        $(`#block_header_${targetDiv}`).fastClick((e) => {
          e.stopPropagation();
          if (!init[targetDiv].expanded) {
            init[targetDiv].expanded = true;
            TweenMax.to(
              `#block_header_icon_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                rotation: 0,
              }
            );
            TweenMax.to(
              `#block_body_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                height: init[targetDiv].maxHeight,
              }
            );
          } else {
            init[targetDiv].expanded = false;
            TweenMax.to(
              `#block_header_icon_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                rotation: 180,
              }
            );
            TweenMax.to(
              `#block_body_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                height: init[targetDiv].minHeight,
              }
            );
          }
        });
        $(`.block_item_${targetDiv}`).off();
        $(`.block_item_${targetDiv}`).fastClick((e) => {
          // e.stopPropagation();
          callback(null, e.target.id, $(`#${e.target.id}`).data("id"));
        });
        break;
      }
      case "seated": {
        init[targetDiv].height = $(`#block_body_${targetDiv}`).outerHeight();
        init[targetDiv].scroll = $(`#block_body_${targetDiv}`).scrollTop();
        const now = Math.floor(Date.now() / 1000);
        const start = now - data.waited.max * 60;
        const end = now - data.waited.min * 60;
        const result = opt.kd.whereSort(
          "activity",
          (obj) => {
            if (
              obj.hasOwnProperty("status") &&
              obj.hasOwnProperty("size") &&
              obj.status >= data.status.min &&
              obj.status <= data.status.max &&
              obj.size >= data.size.min &&
              obj.size <= data.size.max &&
              obj.statusTimes.added >= start &&
              obj.statusTimes.added <= end
            ) {
              return true;
            }
          },
          (obj1, obj2) => {
            if (obj1.statusTimes.added == obj2.statusTimes.added) {
              return 0;
            }
            if (obj1.statusTimes.added > obj2.statusTimes.added) {
              return 1;
            }
            if (obj1.statusTimes.added < obj2.statusTimes.added) {
              return -1;
            }
          }
        );
        thisHTML += `<div class="block_header theme_bg_night_gradient" \
                        id="block_header_${targetDiv}">`;
        thisHTML += `<div class="block_header_h3">${result.length} \
                        <div class="block_header_float" id="block_header_icon_${targetDiv}">\
                        ${icons.lib.doubledown}\
                        </div></div>`;
        thisHTML += `<div class="block_header_h1">${data.h1}</div>`;
        let h2 = data.h2;
        if (data.hasOwnProperty("waitSize")) {
          let waitTime = location.getCurrentWait(data.waitSize);
          if (waitTime < 0) {
            waitTime = 0;
          }
          h2 = `${waitTime}-${waitTime + 5}m`;
        }
        thisHTML += `<div class="block_header_h2">${h2}</div>`;
        thisHTML += "</div>";
        thisHTML += `<div class="block_body block_group_${data.group}" \
                        id="block_body_${targetDiv}">`;
        for (let i = 0; i < result.length; ++i) {
          if (
            !result[i].hasOwnProperty("preference") ||
            result[i].preference === undefined
          ) {
            result[i].preference = "";
          }

          const locationdata = opt.kd.doc("location")[0];

          let sizeIndex = Math.ceil(parseInt(result[i].size, 10) / 2) - 1;
          if (sizeIndex > 6) {
            sizeIndex = 6;
          } else if (sizeIndex < 0) {
            sizeIndex = 0;
          }

          const turnTime =
            locationdata.baseTurn * 60 +
            locationdata.turnTimes[sizeIndex].turnTime * 60;
          const percentStatus3 = Math.floor(
            Math.floor(Date.now() / 1000) - result[i].statusTimes.seated
          );
          let pwidth = Math.round((percentStatus3 / turnTime) * 100);
          const section = result[i].section;
          if (pwidth > 100) {
            pwidth = 100;
          }
          let progressBar = "";
          if (pwidth > 90) {
            progressBar = `width:${pwidth}%; background-color:#00ff00`;
          } else {
            progressBar = `width:${pwidth}%`;
          }

          // result[i].waited = Math.floor((now - result[i].statusTimes.added) / 60);
          const dineTime = Math.floor(
            (Math.floor(Date.now() / 1000) - result[i].statusTimes.seated) / 60
          );
          const waited = `${dineTime}m`;

          if (
            !result[i].hasOwnProperty("alerts") ||
            result[i].alerts === undefined
          ) {
            result[i].alerts = 0;
          }

          let itemColor = "";
          if (
            !result[i].hasOwnProperty("res_id") ||
            result[i].res_id === undefined
          ) {
            result[i].res_id = 0;
          }

          if (result[i].res_id.length > 1) {
            itemColor = ' style="background-color: #42bcf4;"';
          }

          if (result[i].status == 2) {
            itemColor = ' style="background-color: #a8ff38; color:#000;"';
          }

          thisHTML += `<div class="block_item block_item_${targetDiv}" \
                            id="block_item_${targetDiv}_${i}" data-id="${result[i]._id}" \
                            data-filter="${result[i].name}">`;
          thisHTML += `<div class="block_item_size" ${itemColor}>${result[i].size}</div>`;
          thisHTML += `<div class="block_item_name">${result[i].name}</div>`;
          thisHTML += `<div class="block_item_waited">${waited}</div>`;
          thisHTML += '<div class="clear"></div>';

          let sectionBar = "";
          if (result[i].section) {
            sectionBar = `color: \
                        ${func.getColorByBg(
                          conf.vars.sections[result[i].section].color
                        )}; \
                        background-color: ${
                          conf.vars.sections[result[i].section].color
                        }; `;
            if (
              conf.vars.sections[result[i].section].hasOwnProperty("color2")
            ) {
              sectionBar += `border-left: 3px solid \
                            ${conf.vars.sections[result[i].section].color2}; `;
              sectionBar += `border-right: 3px solid \
                            ${conf.vars.sections[result[i].section].color2}; `;
            }
          }

          const table = result[i].table;
          if (result[i].hasOwnProperty("join") && result[i].join.length > 0) {
            // table = `${table}+${result[i].join.join('+')}`;
          }

          thisHTML += `<div class="context_table_label_table_seated" \
                    style="${sectionBar}">${table}</div>`;

          thisHTML += `<div id="context_table_label_progress_bg">\
                                <div id="context_table_label_progress_bar" style="${progressBar}"> \
                                </div></div>`;

          // thisHTML += `<div class="block_item_preference">${result[i].table}</div>`;
          // thisHTML += `<div class="block_item_alerts">${result[i].alerts} \
          //             <i class="fa fa-bell-o"></i></div>`;
          thisHTML += '<div class="clear"></div>';
          if (
            result[i].hasOwnProperty("res_id") &&
            result[i].res_id.length > 1
          ) {
            thisHTML += `<div class="block_item_reserved_icon">\
                                ${icons.lib.calendaralt}</div>`;
          }
          thisHTML += '<div class="clear"></div>';
          thisHTML += "</div>";
        }
        thisHTML += "</div>";
        $(`#${targetDiv}`).html(thisHTML);
        if (init[targetDiv].minHeight >= result.length * itemHeight) {
          init[targetDiv].minHeight = result.length * itemHeight;
        }
        if (!init[targetDiv].exist) {
          init[targetDiv].exist = true;
          TweenMax.to(`#block_body_${targetDiv}`, 0, {
            height: 0,
          });
          if (data.expand) {
            if (init[targetDiv].hasOwnProperty("maxHeight")) {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: init[targetDiv].maxHeight,
                }
              );
            } else {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: result.length * itemHeight,
                }
              );
            }
          } else {
            TweenMax.to(
              `#block_body_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                height: init[targetDiv].minHeight,
              }
            );
          }
        } else {
          TweenMax.to(`#block_body_${targetDiv}`, 0, {
            height: init[targetDiv].height,
          });
          if (init[targetDiv].expanded) {
            if (init[targetDiv].hasOwnProperty("maxHeight")) {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: init[targetDiv].maxHeight,
                }
              );
            } else {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: result.length * itemHeight,
                }
              );
            }
          } else {
            TweenMax.to(`#block_body_${targetDiv}`, 0, {
              height: init[targetDiv].minHeight,
            });
          }
          TweenMax.to(`#block_body_${targetDiv}`, 0, {
            scrollTo: init[targetDiv].scroll,
          });
        }
        $(`#block_header_${targetDiv}`).off();
        $(`#block_header_${targetDiv}`).fastClick((e) => {
          e.stopPropagation();
          if (!init[targetDiv].expanded) {
            init[targetDiv].expanded = true;
            TweenMax.to(
              `#block_header_icon_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                rotation: 0,
              }
            );
            if (init[targetDiv].hasOwnProperty("maxHeight")) {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: init[targetDiv].maxHeight,
                }
              );
            } else {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: result.length * itemHeight,
                }
              );
            }
          } else {
            init[targetDiv].expanded = false;
            TweenMax.to(
              `#block_header_icon_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                rotation: 180,
              }
            );
            TweenMax.to(
              `#block_body_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                height: init[targetDiv].minHeight,
              }
            );
          }
        });
        $(`.block_item_${targetDiv}`).off();
        $(`.block_item_${targetDiv}`).fastClick((e) => {
          // e.stopPropagation();
          callback(null, e.target.id, $(`#${e.target.id}`).data("id"));
        });
        break;
      }
      case "resnoshows": {
        init[targetDiv].height = $(`#block_body_${targetDiv}`).outerHeight();
        init[targetDiv].scroll = $(`#block_body_${targetDiv}`).scrollTop();
        const reservations = [];
        const prereservations = opt.kd.where(
          "reservation",
          (obj) => {
            if (obj.date === opt.date && obj.status === 6) {
              return true;
            }
          },
          "time"
        );
        for (let i = 0; i < prereservations.length; ++i) {
          if (
            opt.hasOwnProperty("filter") &&
            opt.filter.hasOwnProperty("name") &&
            opt.filter.name
          ) {
            if (
              opt.kd.localstore.data.filter.name.length === 0 ||
              prereservations[i].name
                .toLowerCase()
                .indexOf(opt.kd.localstore.data.filter.name.toLowerCase()) > -1
            ) {
              reservations.push(prereservations[i]);
            }
          } else {
            reservations.push(prereservations[i]);
          }
        }

        thisHTML += `<div class="block_header theme_bg_night_gradient" \
                            id="block_header_${targetDiv}">`;
        thisHTML += `<div class="block_header_h3">${reservations.length} \
                        <div class="block_header_float" id="block_header_icon_${targetDiv}">\
                        ${icons.lib.doubledown}\
                        </div></div>`;
        thisHTML += `<div class="block_header_h1">${data.h1}</div>`;
        thisHTML += `<div class="block_header_h2">${data.h2}</div>`;
        thisHTML += "</div>";
        thisHTML += `<div class="block_body block_group_${data.group}" \
                            id="block_body_${targetDiv}">`;
        for (let i = 0; i < reservations.length; ++i) {
          if (
            !reservations[i].hasOwnProperty("preference") ||
            reservations[i].preference === undefined
          ) {
            reservations[i].preference = "";
          }

          thisHTML += `<div class="block_item block_item_${targetDiv}" \ 
                                id="block_item_${targetDiv}_${i}" data-id="${reservations[i]._id}" \
                                data-filter="${reservations[i].name}">`;
          thisHTML += `<div class="block_item_size">${reservations[i].size}</div>`;
          thisHTML += `<div class="block_item_name">${reservations[i].name}</div>`;
          thisHTML += `<div class="block_item_waited">\
                    ${indexToTime(reservations[i].time, time24)}</div>`;
          thisHTML += '<div class="clear"></div>';
          if (!opt.hasOwnProperty("mode")) {
            thisHTML += `<div class="block_item_preference">\
                        ${reservations[i].preference}</div>`;
            thisHTML += '<div class="block_item_alerts"></div>';
          }
          thisHTML += '<div class="clear"></div>';
          if (opt.hasOwnProperty("mode")) {
            thisHTML += '<div class="block_item_date">';
            thisHTML += moment(reservations[i].date * 1000).format(
              l.translate("dddd, MMMM Do YYYY")
            );
            thisHTML += "</div>";
          } else {
            thisHTML += '<div class="block_item_reserved_icon">';
            thisHTML += `${icons.lib.calendaralt}</div>`;
          }
          thisHTML += genIcons(reservations[i].notes);
          thisHTML += '<div class="clear"></div>';
          thisHTML += "</div>";
        }

        thisHTML += "</div>";
        $(`#${targetDiv}`).html(thisHTML);
        if (init[targetDiv].minHeight >= reservations.length * itemHeight) {
          init[targetDiv].minHeight = reservations.length * itemHeight;
        }
        if (!init[targetDiv].exist) {
          init[targetDiv].exist = true;
          TweenMax.to(`#block_body_${targetDiv}`, 0, {
            height: 0,
          });
          if (data.expand) {
            if (init[targetDiv].hasOwnProperty("maxHeight")) {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: init[targetDiv].maxHeight,
                }
              );
            } else {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: "auto",
                }
              );
            }
          } else {
            TweenMax.to(
              `#block_body_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                height: init[targetDiv].minHeight,
              }
            );
          }
        } else {
          TweenMax.to(`#block_body_${targetDiv}`, 0, {
            height: init[targetDiv].height,
          });
          if (init[targetDiv].expanded) {
            if (init[targetDiv].hasOwnProperty("maxHeight")) {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: init[targetDiv].maxHeight,
                }
              );
            } else {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: "auto",
                }
              );
            }
          } else {
            TweenMax.to(`#block_body_${targetDiv}`, 0, {
              height: init[targetDiv].minHeight,
            });
          }
          TweenMax.to(`#block_body_${targetDiv}`, 0, {
            scrollTo: init[targetDiv].scroll,
          });
        }
        $(`#block_header_${targetDiv}`).off();
        $(`#block_header_${targetDiv}`).fastClick((e) => {
          e.stopPropagation();
          if (!init[targetDiv].expanded) {
            init[targetDiv].expanded = true;
            TweenMax.to(
              `#block_header_icon_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                rotation: 0,
              }
            );
            if (init[targetDiv].hasOwnProperty("maxHeight")) {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: init[targetDiv].maxHeight,
                }
              );
            } else {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: "auto",
                }
              );
            }
          } else {
            init[targetDiv].expanded = false;
            TweenMax.to(
              `#block_header_icon_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                rotation: 180,
              }
            );
            TweenMax.to(
              `#block_body_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                height: init[targetDiv].minHeight,
              }
            );
          }
        });
        $(`.block_item_${targetDiv}`).off();
        $(`.block_item_${targetDiv}`).fastClick((e) => {
          // e.stopPropagation();
          callback(null, e.target.id, $(`#${e.target.id}`).data("id"));
        });
        break;
      }
      case "reservation": {
        init[targetDiv].height = $(`#block_body_${targetDiv}`).outerHeight();
        init[targetDiv].scroll = $(`#block_body_${targetDiv}`).scrollTop();
        let reservations = [];
        if (opt.hasOwnProperty("mode") && opt.mode === "name") {
          reservations = opt.kd.where(
            "reservation",
            (obj) => {
              if (
                obj.date >= opt.date &&
                obj.status === 1 &&
                obj.requireConfirmation === 0 &&
                (obj.name.toLowerCase().indexOf(opt.query.toLowerCase()) > -1 ||
                  obj.customNotes
                    .toLowerCase()
                    .indexOf(opt.query.toLowerCase()) > -1)
              ) {
                return true;
              }
            },
            "time"
          );
        } else {
          const prereservations = opt.kd.where(
            "reservation",
            (obj) => {
              if (
                obj.date === opt.date &&
                obj.status === 1 &&
                obj.requireConfirmation === 0
              ) {
                return true;
              }
            },
            "time"
          );
          for (let i = 0; i < prereservations.length; ++i) {
            if (
              opt.hasOwnProperty("filter") &&
              opt.filter.hasOwnProperty("name") &&
              opt.filter.name
            ) {
              if (
                opt.kd.localstore.data.filter.name.length === 0 ||
                prereservations[i].name
                  .toLowerCase()
                  .indexOf(opt.kd.localstore.data.filter.name.toLowerCase()) >
                  -1
              ) {
                reservations.push(prereservations[i]);
              }
            } else {
              reservations.push(prereservations[i]);
            }
          }
        }

        thisHTML += `<div class="block_header theme_bg_night_gradient" \
                            id="block_header_${targetDiv}">`;
        thisHTML += `<div class="block_header_h3">${reservations.length} \
                        <div class="block_header_float" id="block_header_icon_${targetDiv}">\
                        ${icons.lib.doubledown}\
                        </div></div>`;
        thisHTML += `<div class="block_header_h1">${data.h1}</div>`;
        thisHTML += `<div class="block_header_h2">${data.h2}</div>`;
        thisHTML += "</div>";
        thisHTML += `<div class="block_body block_group_${data.group}" \
                            id="block_body_${targetDiv}">`;
        if (data.hasOwnProperty("detailed") && data.detailed) {
          thisHTML += '<div class="theme_gray">';
          thisHTML += `<div class="block_item_detail_col block_item_detail_col1">\
                    ${l.translate("Time")}</div>`;
          thisHTML += `<div class="block_item_detail_col block_item_detail_col2">\
                    ${l.translate("S")}</div>`;
          thisHTML += `<div class="block_item_detail_col block_item_detail_col3">\
                    ${l.translate("Name")}</div>`;
          thisHTML += `<div class="block_item_detail_col block_item_detail_col4">\
                    ${l.translate("Table(s)")}</div>`;
          thisHTML += `<div class="block_item_detail_col block_item_detail_col5">\
                    ${l.translate("Phone")}</div>`;
          thisHTML += `<div class="block_item_detail_col block_item_detail_col6">\
                    ${l.translate("Seat Pref")}</div>`;
          thisHTML += `<div class="block_item_detail_col block_item_detail_col4">\
                    ${l.translate("Notes")}</div>`;
          thisHTML += '<div class="clear"></div>';
          thisHTML += "</div>";
        }
        for (let i = 0; i < reservations.length; ++i) {
          if (
            !reservations[i].hasOwnProperty("preference") ||
            reservations[i].preference === undefined
          ) {
            reservations[i].preference = "";
          }
          if (data.hasOwnProperty("detailed") && data.detailed) {
            // Reservation time Party Size Party Name Preselected Tables Seating Notes

            // would also be nice if this was printable / exportable to CSV.
            thisHTML += `<div class="block_item_detail block_item_${targetDiv}" \ 
                                    id="block_item_${targetDiv}_${i}" \
                                    data-id="${reservations[i]._id}" \
                                    data-filter="${reservations[i].name}">`;
            thisHTML += `<div class="block_item_detail_col block_item_detail_col1">\
                        ${indexToTime(reservations[i].time, time24)}</div>`;
            thisHTML += `<div class="block_item_detail_col block_item_detail_col2">\
                        ${reservations[i].size}</div>`;
            thisHTML += `<div class="block_item_detail_col block_item_detail_col3">\
                        ${reservations[i].name}</div>`;
            thisHTML +=
              '<div class="block_item_detail_col block_item_detail_col4">';
            if (
              reservations[i].hasOwnProperty("preSelect") &&
              reservations[i].preSelect.length > 0
            ) {
              for (let s = 0; s < reservations[i].preSelect.length; ++s) {
                thisHTML += `${reservations[i].preSelect[s]}, `;
              }
              thisHTML = thisHTML.substr(0, thisHTML.length - 2);
            }
            thisHTML += "</div>";
            thisHTML += `<div class="block_item_detail_col block_item_detail_col5">\
                    ${formatCell(reservations[i].cell)}</div>`;
            thisHTML += `<div class="block_item_detail_col block_item_detail_col6">\
                        ${reservations[i].preference}</div>`;
            thisHTML +=
              '<div class="block_item_detail_col block_item_detail_col7">';
            let hit = false;
            if (
              reservations[i].hasOwnProperty("customNotes") &&
              reservations[i].customNotes
            ) {
              hit = true;
              thisHTML += `${reservations[i].customNotes}, `;
            }
            if (
              reservations[i].hasOwnProperty("notes") &&
              reservations[i].notes.length > 0
            ) {
              for (let s = 0; s < reservations[i].notes.length; ++s) {
                if (reservations[i].notes[s].active === 1) {
                  hit = true;
                  thisHTML += `${reservations[i].notes[s].value}, `;
                }
              }
              if (hit) {
                thisHTML = thisHTML.substr(0, thisHTML.length - 2);
              }
            }
            thisHTML += "</div>";
            thisHTML += '<div class="clear"></div>';
            thisHTML += "</div>";
          } else {
            thisHTML += `<div class="block_item block_item_${targetDiv}" \ 
                                    id="block_item_${targetDiv}_${i}" \
                                    data-id="${reservations[i]._id}" \
                                    data-filter="${reservations[i].name}">`;
            thisHTML += `<div class="block_item_size">${reservations[i].size}</div>`;
            thisHTML += `<div class="block_item_name">${reservations[i].name}</div>`;
            thisHTML += `<div class="block_item_waited">\
                        ${indexToTime(reservations[i].time, time24)}</div>`;
            thisHTML += '<div class="clear"></div>';
            if (!opt.hasOwnProperty("mode")) {
              thisHTML += `<div class="block_item_preference">\
                            ${reservations[i].preference}</div>`;
              thisHTML += '<div class="block_item_alerts"></div>';
            }
            thisHTML += '<div class="clear"></div>';
            if (opt.hasOwnProperty("mode")) {
              thisHTML += '<div class="block_item_date">';
              thisHTML += moment(reservations[i].date * 1000).format(
                l.translate("dddd, MMMM Do YYYY")
              );
              thisHTML += "</div>";
            } else {
              thisHTML += '<div class="block_item_reserved_icon">';
              thisHTML += `${icons.lib.calendaralt}</div>`;
            }
            thisHTML += genIcons(reservations[i].notes);
            thisHTML += '<div class="clear"></div>';
            thisHTML += "</div>";
          }
        }
        if (opt.hasOwnProperty("confirmation") && opt.confirmation) {
          thisHTML += `<div class="btn5 reservation_remind_all" data-date="${
            opt.date
          }" \
                    id="remind_${opt.date}">${l.translate(
            "Remind This Date Now"
          )}</div>`;
          thisHTML += '<div class="content_standard_spacer1"></div>';
        }

        thisHTML += "</div>";
        $(`#${targetDiv}`).html(thisHTML);
        if (init[targetDiv].minHeight >= reservations.length * itemHeight) {
          init[targetDiv].minHeight = reservations.length * itemHeight;
        }
        if (!init[targetDiv].exist) {
          init[targetDiv].exist = true;
          TweenMax.to(`#block_body_${targetDiv}`, 0, {
            height: 0,
          });
          if (data.expand) {
            if (init[targetDiv].hasOwnProperty("maxHeight")) {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: init[targetDiv].maxHeight,
                }
              );
            } else {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: "auto",
                }
              );
            }
          } else {
            TweenMax.to(
              `#block_body_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                height: init[targetDiv].minHeight,
              }
            );
          }
        } else {
          TweenMax.to(`#block_body_${targetDiv}`, 0, {
            height: init[targetDiv].height,
          });
          if (init[targetDiv].expanded) {
            if (init[targetDiv].hasOwnProperty("maxHeight")) {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: init[targetDiv].maxHeight,
                }
              );
            } else {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: "auto",
                }
              );
            }
          } else {
            TweenMax.to(`#block_body_${targetDiv}`, 0, {
              height: init[targetDiv].minHeight,
            });
          }
          TweenMax.to(`#block_body_${targetDiv}`, 0, {
            scrollTo: init[targetDiv].scroll,
          });
        }
        $(`#block_header_${targetDiv}`).off();
        $(`#block_header_${targetDiv}`).fastClick((e) => {
          e.stopPropagation();
          if (!init[targetDiv].expanded) {
            init[targetDiv].expanded = true;
            TweenMax.to(
              `#block_header_icon_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                rotation: 0,
              }
            );
            if (init[targetDiv].hasOwnProperty("maxHeight")) {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: init[targetDiv].maxHeight,
                }
              );
            } else {
              TweenMax.to(
                `#block_body_${targetDiv}`,
                conf.vars.interfaceSpeed / 2,
                {
                  height: "auto",
                }
              );
            }
          } else {
            init[targetDiv].expanded = false;
            TweenMax.to(
              `#block_header_icon_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                rotation: 180,
              }
            );
            TweenMax.to(
              `#block_body_${targetDiv}`,
              conf.vars.interfaceSpeed / 2,
              {
                height: init[targetDiv].minHeight,
              }
            );
          }
        });
        $(`.block_item_${targetDiv}`).off();
        $(`.block_item_${targetDiv}`).fastClick((e) => {
          e.stopPropagation();
          e.preventDefault();
          callback(null, e.target.id, $(`#${e.target.id}`).data("id"));
        });
        $(".reservation_remind_all").off();
        $(".reservation_remind_all").fastClick((e) => {
          e.stopPropagation();
          e.preventDefault();
          callback(null, "remind", $(`#${e.target.id}`).data("date"));
        });
        break;
      }
      case "sections": {
        const uniqueSections = [];
        let d = 0;
        const locationdata = opt.kd.doc("location")[0];
        if (locationdata) {
          const templatedata = Object.assign(
            {},
            opt.kd.doc("template", locationdata.template)[0]
          );

          templatedata.tables.forEach((table) => {
            if (!uniqueSections.includes(table.section)) {
              uniqueSections.push(table.section);
            }
          });

          uniqueSections.sort();

          uniqueSections.forEach((section) => {
            let btnStyle = `border-top-color: ${conf.vars.sections[section].color}; `;
            if (conf.vars.sections[section].hasOwnProperty("color2")) {
              btnStyle += `border-left: 5px solid ${conf.vars.sections[section].color2}; `;
              btnStyle += `border-right: 5px solid ${conf.vars.sections[section].color2}; `;
            }
            let sectionDesc = section;
            for (let i = 0; i < locationdata.assignments.length; ++i) {
              if (locationdata.assignments[i].section === section) {
                sectionDesc = locationdata.assignments[i].server;
                break;
              }
            }

            thisHTML += `<div id="layout_section_${d}" class="layout_section_btn" \
                                data-value="${section}" data-description="${sectionDesc}" \
                                style="${btnStyle}">`;
            thisHTML += sectionDesc;
            thisHTML += "</div>";
            ++d;
          });

          thisHTML += '<div class="content_standard_spacer1"></div>';

          $(`#${targetDiv}`).html(thisHTML);

          $(".layout_section_btn").off();
          $(".layout_section_btn").fastClick((e) => {
            e.stopPropagation();
            const result = {
              target_id: e.target.id,
              value: $(`#${e.target.id}`).data("value"),
              description: $(`#${e.target.id}`).data("description"),
            };
            callback(null, result);
          });
        }
        break;
      }
      case "note": {
        let d = 0;
        const notedata = opt.kd.where(
          "note",
          (obj) => {
            if (obj.active === 1) {
              return true;
            }
          },
          "_kd.updated"
        );
        let noteCount = 0;
        if (notedata) {
          noteCount = notedata.length;
          notedata.forEach((note) => {
            thisHTML += `<div id="note_${d}" class="layout_note_btn" \
                                data-value="${note._id}" data-description="${note.subject}">`;
            thisHTML += note.subject;
            thisHTML += "</div>";
            ++d;
          });

          thisHTML += '<div class="content_standard_spacer1"></div>';

          $(`#${targetDiv}`).html(thisHTML);

          $(".layout_note_btn").off();
          $(".layout_note_btn").fastClick((e) => {
            e.stopPropagation();
            const result = {
              target_id: e.target.id,
              value: $(`#${e.target.id}`).data("value"),
              description: $(`#${e.target.id}`).data("description"),
            };
            callback(null, result);
          });
        }
        $("#tab_count_wide_notes").html(noteCount);
        break;
      }
      case "filter": {
        const locationdata = opt.kd.doc("location")[0];

        let d = 0;
        data.tableStatus.forEach((status) => {
          let checkMark = "";
          let selectedStyle = "";
          if (status.value === opt.kd.localstore.data.chart_status_filter) {
            checkMark = '<i class="fa fa-check"></i> ';
            selectedStyle = "background-color:#777;";
          }
          let style = "";
          if (
            locationdata.tableStatus[d - 1] &&
            locationdata.tableStatus[d - 1].color
          ) {
            style = `border: 1px solid ${
              locationdata.tableStatus[d - 1].color
            }`;
          }
          thisHTML += `<div id="layout_filter_${d}" class="layout_filter_btn" \
                            data-value="${status.value}" style="${selectedStyle}${style}" \
                            data-description="${status.description}">`;
          thisHTML += checkMark + status.description;
          thisHTML += "</div>";
          ++d;
        });

        thisHTML += '<div class="content_standard_spacer1"></div>';

        $(`#${targetDiv}`).html(thisHTML);

        $(".layout_filter_btn").off();
        $(".layout_filter_btn").fastClick((e) => {
          e.stopPropagation();
          const result = {
            target_id: e.target.id,
            value: $(`#${e.target.id}`).data("value"),
            description: $(`#${e.target.id}`).data("description"),
          };
          callback(null, result);
        });

        break;
      }
      default: {
        break;
      }
    }
  }
  // this could be a performance issue, so check here first if there is a problem.
  // filter($('#search_box').val());
};

/*
const filter = (targetDiv, filterBy) => {
    $('#' + targetDiv).attr('data-filter', filterBy);
    $( ".block_item_" + targetDiv).each(function( index ) {
        if ($( this ).data('filter').indexOf(filterBy) > -1 || !filterBy) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
}
*/

module.exports = {
  create,
  destroy,
  filter,
  indexToTime,
  formatCell,
};



/** WEBPACK FOOTER **
 ** ./src/components/block/index.js
 **/